<template>
    <PageHeaderText
        v-if="pageHeader?.type === 'text'"
        :page-header="pageHeader"
    />
    <PageHeaderButton
        v-else-if="pageHeader?.type === 'button'"
        :page-header="pageHeader"
    />
    <PageHeaderQuote
        v-else-if="pageHeader?.type === 'quote'"
        :page-header="pageHeader"
    />
    <PageHeaderAnimation
        v-else-if="pageHeader?.type === 'animation'"
        :page-header="pageHeader"
    />
    <PageHeaderBlog
        v-else-if="pageHeader?.type === 'blog'"
        :page-header="pageHeader"
    />
    <PageHeaderJob
        v-else-if="pageHeader?.type === 'job'"
        :page-header="pageHeader"
    />
    <PageHeaderGuide
        v-else-if="pageHeader?.type === 'guide'"
        :page-header="pageHeader"
    />
    <PageHeaderNone
        v-else-if="pageHeader?.type === 'none'"
        :page-header="pageHeader"
    />
    <PageHeaderIframe
        v-else-if="pageHeader?.type === 'iframe'"
        :page-header="pageHeader"
    />
    <PageHeaderScript
        v-else-if="pageHeader?.type === 'script'"
        :page-header="pageHeader"
    />
</template>

<script setup>
import PageHeaderBlog from './header-types/header-blog/watson-theme-header-blog.vue';
import PageHeaderButton from './header-types/header-button/watson-theme-header-button.vue';
import PageHeaderGuide from './header-types/header-guide/watson-theme-header-guide.vue';
import PageHeaderIframe from './header-types/header-iframe/watson-theme-header-iframe.vue';
import PageHeaderJob from './header-types/header-job/watson-theme-header-job.vue';
import PageHeaderNone from './header-types/header-none/watson-theme-header-none.vue';
import PageHeaderQuote from './header-types/header-quote/watson-theme-header-quote.vue';
import PageHeaderScript from './header-types/header-script/watson-theme-header-script.vue';
import PageHeaderText from './header-types/header-text/watson-theme-header-text.vue';
import PageHeaderAnimation from './header-types/header-animation/watson-theme-header-animation.vue';

defineProps({
    pageHeader: {
        type: Object,
        required: false,
        default: null,
    },
});
</script>
